export const minecraft12110 = {
  version: '1.21.10',
  title: 'The Copper Age con arreglos de bugs',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Minecraft_Fall_Drop_Campaign_Key_Art_DotNet_Blog_Editorial_1280x768.jpg',
  releases: [
    {
      id: "220hY1Zws",
      version: "beta-0.6-1.0.4",
      date: "Jan 11, 2026",
      changelog: "Penultima versión beta para Minecraft 1.21.10 Copper Age con agregados finales y correcciones de bugs adicionales",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.6-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "210hY1Zws",
      version: "beta-0.5-1.0.4",
      date: "Dec 7, 2025",
      changelog: "Quinta versión beta para Minecraft 1.21.10 Copper Age con optimizaciones finales y correcciones de bugs adicionales",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.5-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "200hY0Zwr",
      version: "beta-0.4-1.0.4",
      date: "Nov 4, 2025",
      changelog: "Cuarta versión beta para Minecraft 1.21.10 Copper Age con optimizaciones finales y correcciones de bugs adicionales",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.4-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "190hY9Zwq",
      version: "beta-0.3-1.0.4",
      date: "Oct 24, 2025",
      changelog: "Tercera versión beta para Minecraft 1.21.10 Copper Age con aún más mods agregados y optimizaciones avanzadas",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.3-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "180hY8Zwp",
      version: "beta-0.2-1.0.4",
      date: "Oct 17, 2025",
      changelog: "Segunda versión beta para Minecraft 1.21.10 Copper Age con más mods agregados y correcciones de bugs adicionales",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "170hY7Zwo",
      version: "beta-0.1-1.0.4",
      date: "Oct 11, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.10 Copper Age con mods básicos optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.10",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};
